import {toBackendDateTime} from "./DateUtils";

function constructTableRequestParams(filters = {},pageable = {}){
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        //checks also undefined
        if(value == null || value === '')return;

        if(Array.isArray(value)) {
            value.forEach((value) => {
                params.append(key, value instanceof Date ? toBackendDateTime(value) : value);
            })
        }else if (value instanceof Date) {
            params.append(key, toBackendDateTime(value));
        } else {
            params.append(key, value);
        }

    })

    Object.entries(pageable).forEach(([key, value]) => {
        if(!value)return;

        params.append(key,value)
    })

    return params
}

function handleSort(column,pageable,setPageable) {
    if (!column) return

    const sort = pageable.sort;
    let newSort
    let currentColumn, currentOrder

    if (sort) {
        currentOrder = sort.split(',').pop();
        currentColumn = sort.split(',').slice(0, -1).join(',');
    }

    if (currentOrder && currentColumn === column) {
        newSort = column + ',' + (currentOrder === 'asc' ? 'desc' : 'asc');
    } else {
        newSort = column + ',' + 'asc'
    }

    setPageable({
        ...pageable,
        sort: newSort,
    });
}

export { constructTableRequestParams, handleSort };



// WEBPACK FOOTER //
// ./src/utils/TableUtils.js